module.exports = __webpack_public_path__ + "img/add.bb7bc78b.svg";